import PropTypes from 'prop-types';
import { stripReplyFallback } from '../../utils/replyUtils';
import { diffWords } from 'diff';
import './EditHistoryMessage.css';

const EditHistoryMessage = ({ previousEdit, currentEdit, isOriginal, timestamp, timeOnly }) => {
  let prevContent, currContent;
  // If no previousEdit, show the original message only (no diff)
  if (!previousEdit) {
    prevContent = null;
    currContent = currentEdit.getOriginalContent();
  } else {
    prevContent = isOriginal ? previousEdit.getOriginalContent() : previousEdit.getContent();
    currContent = currentEdit.getContent();
  }

  let dateStr = 'Unknown time';
  if (timestamp) {
    const date = new Date(timestamp);
    if (timeOnly) {
      // Show only HH:MM
      dateStr = date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false });
    } else {
      dateStr = date.toLocaleString();
    }
  }

  // For edit events, use m.new_content.body instead of root body (which has "* " fallback prefix)
  const getBodyFromContent = (content) => {
    if (!content) return '';
    // Edit events have m.new_content with the actual content (without "* " prefix)
    return content['m.new_content']?.body || content.body || '';
  };

  const prevBody = prevContent ? stripReplyFallback(getBodyFromContent(prevContent)) : '';
  const currBody = stripReplyFallback(getBodyFromContent(currContent));

  let rendered;
  if (!previousEdit) {
    // Just show the original message, no diff
    rendered = <span>{currBody}</span>;
  } else {
    const diff = diffWords(prevBody, currBody);
    rendered = diff.map((part, index) => {
      if (part.added) {
        return <span key={index} className="edit-history-message-added">{part.value}</span>;
      } else if (part.removed) {
        return <span key={index} className="edit-history-message-removed">{part.value}</span>;
      } else {
        return <span key={index}>{part.value}</span>;
      }
    });
  }

  return (
    <div className="edit-history-message-row">
      <span className="edit-history-message-timestamp">{dateStr}</span>
      <span className="edit-history-message-diff edit-history-message-diff-wrap">{rendered}</span>
    </div>
  );
};

EditHistoryMessage.propTypes = {
  previousEdit: PropTypes.object,
  currentEdit: PropTypes.object.isRequired,
  isOriginal: PropTypes.bool,
  timestamp: PropTypes.number,
  timeOnly: PropTypes.bool,
};

export default EditHistoryMessage;
